
<div class="d-flex align-items-center justify-content-end me-3">
  <div class="dropdown me-3 ">
    <a class="nav-link text-dark dropdown-toggle"
      role="button"
      data-bs-toggle="dropdown"
      id="dropdownMenuButtonDark"
      aria-expanded="false">
      @if (userData) {
        <span class="fw-bold">
          {{ userData.fullName || userData.username }}
        </span>
      }
    </a>
    <ul class="dropdown-menu rounded-3 mt-4 dropdown-profile">
      <li>
        <a routerLink="/profile" class="dropdown-item text-center ">
          <i class="fa fa-user me-2"></i> Profile
        </a>
      </li>
      <li><hr class="dropdown-divider"></li>
      <li>
        <a (click)="signOut()" class="dropdown-item text-center"
          role="button">
          <i class="fa fa-power-off me-2"></i> SignOut
        </a>
      </li>
    </ul>
  </div>
  <div class="ms-2 me-3">
    <app-material-image-viewer
      [documentId]="user?.profileImageId ?? ''"
      [alt]="userData?.fullName ?? ''"
      class="profile-avatar">
    </app-material-image-viewer>
  </div>
</div>